<div class="app-content">
  <div class="intro-text">
      <p>{{'indoor.amateur.intro' | transloco}}</p>
  </div>
  <div class="content-wrapper">
    <app-series-amateur-ranking-filters></app-series-amateur-ranking-filters>
    <app-series-amateur-ranking-list class="app-amateur-ranking-list-indoor app-ranking"></app-series-amateur-ranking-list>
  </div>
</div>
